var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 13,
    viewBox: "0 0 16 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7_132)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5 0.8H0.4C0.2 0.8 0 0.6 0 0.4C0 0.2 0.2 0 0.4 0H15.5C15.7 0 15.9 0.2 15.9 0.4C15.9 0.6 15.7 0.8 15.5 0.8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5 6.8H0.4C0.2 6.8 0 6.6 0 6.4C0 6.2 0.2 6 0.4 6H15.5C15.7 6 15.9 6.2 15.9 6.4C15.9 6.6 15.7 6.8 15.5 6.8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5 12.8H0.4C0.2 12.8 0 12.6 0 12.4C0 12.2 0.2 12 0.4 12H15.5C15.7 12 15.9 12.2 15.9 12.4C15.9 12.6 15.7 12.8 15.5 12.8Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7_132"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.9,
    height: 12.8,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.23bc3833b2b2806e24a647bf0f475be4.svg";
export { ForwardRef as ReactComponent };